import React, { Component } from 'react';
import TableText from "@/components/table/TableText";
import { Table } from 'antd';
import getJson, { calculation, sum } from '../../../method';
import moment from 'moment';

const defaultData = [{
    name: "酒店整体人效指数",
    name_code: "hotel",
    now_year: 0,
    last_year: 0,
    variance: 0
}, {
    name: "F&B人效指数",
    name_code: "fb",
    now_year: 0,
    last_year: 0,
    variance: 0
}, {
    name: "Rooms人效指数",
    name_code: "rooms",
    now_year: 0,
    last_year: 0,
    variance: 0
}]

class Productivity extends Component {

    render() {
        const year = moment(this.props.date).format('YYYY');
        const columns = [
            {
                title: ``,
                dataIndex: 'name',
                key: 'name',
                align: "center",
                width: 500,
                render: (text, record, index) => {
                    const props = {
                        text, index, type: 'text', name: "name",
                    };
                    return <TableText data={props} />
                }
            },
            {
                title: `今年YTD年累计`,
                dataIndex: 'now_year',
                key: 'now_year',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const props = {
                        text, index, type: 'number', name: "now_year", compared: {
                            title: [`今年YTD年累计`],
                            record,
                            sqlName: "_7_7_index"
                        }
                    };
                    return <TableText data={props} />
                }
            },
            {
                title: `去年YTD年累计`,
                dataIndex: 'last_year',
                key: 'last_year',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const props = {
                        text, index, type: 'number', name: "last_year", compared: {
                            title: [`去年YTD年累计`],
                            record,
                            sqlName: "_7_7_index"
                        }
                    };
                    return <TableText data={props} />
                }
            },
            {
                title: "Variance",
                dataIndex: 'variance',
                key: 'variance',
                align: "center",
                width: 300,
                render: (text, record, index) => {
                    const props = {
                        text, index, type: 'percent', name: "variance", compared: {
                            title: [`Variance`],
                            record,
                            sqlName: "_7_7_index"
                        }
                    };
                    return <TableText data={props} />
                }
            }
        ];


        const { data, data7_1, dataSource } = this.props;

        return (
            <Table
                style={{ marginTop: 20 }}
                columns={columns}
                dataSource={compute(data, data7_1, dataSource)}
                size="middle"
                bordered
                pagination={false}
                className="content"
                rowKey={record => record.name}
            />
        );
    }
}

export default Productivity;


export function compute(data, data7_1, dataSource) {
    dataSource = dataSource && dataSource.length > 0 ? [...dataSource] : [...defaultData];
    ['now_year', 'last_year'].forEach(name => {
        const name7_1 = name == 'now_year' ? "year_thisy_payroll_cost" : 'year_lasty_payroll_cost';
        dataSource[0][name] = calculation(
            getJson([5, name], data),
            sum([
                getJson([16, name7_1], data7_1),
                getJson([19, name7_1], data7_1)
            ])
        );
        dataSource[1][name] = calculation(
            getJson([7, name], data),
            sum([
                getJson([17, name7_1], data7_1),
                getJson([36, name], data)
            ])
        );
        dataSource[2][name] = calculation(
            getJson([6, name], data),
            sum([
                getJson([28, name], data),
                getJson([18, name7_1], data7_1)
            ])
        );
    });

    dataSource.forEach((item, i) => {
        dataSource[i].variance = calculation(dataSource[i].now_year - dataSource[i].last_year, dataSource[i].last_year, 4)
    });
    return dataSource
}


// WEBPACK FOOTER //
// ./src/hr/table/9.0/Productivity.js